import { motion, useInView } from "motion/react";
import { useRef } from "react";

export default function ScrollReveal({ children }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: "-20% 0px -20% 0px", once: false });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 , filter: 'blur(15px)'}}
      animate={isInView ? { opacity: 1, y: 0 , filter: 'blur(0px)'} : {}}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
